import React from "react";
import cn from "classnames";
import eyeIcon from "@src/assets/svg/eye-icon.svg";
import eyeIconSlashed from "@src/assets/svg/eye-slash-icon.svg";
import styles from "./nodes-selection-number-eyes.module.scss";

interface NodesSelectionNumberEyesProps {
  type: "hidden" | "shown";
  amount: number;
}

const cssClassName = "nodes-selection-number-eyes";

export const NodesSelectionNumberEyes = ({
  type,
  amount,
}: NodesSelectionNumberEyesProps) => {
  const returnIconBasedOnType = (type: string) =>
    type === "shown" ? eyeIcon : eyeIconSlashed;

  return (
    <div className={styles[cssClassName]}>
      <img src={returnIconBasedOnType(type)} alt="" />
      <p
        className={cn(styles[`${cssClassName}__text`], {
          [styles[`${cssClassName}__text--inactive-grey`]]: type === "hidden",
        })}
      >
        {" "}
        {amount}
      </p>
    </div>
  );
};
